import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/zh-cn';
dayjs.extend(utc);
dayjs.extend(timezone);
// 全局中文：antd DatePicker/RangePicker 日历的星期/月份等文案随 dayjs 全局 locale，
// 仅靠 ConfigProvider locale 不够（那只管按钮/占位）。设为 zh-cn 让面板整体中文。
dayjs.locale('zh-cn');
export const BJ = 'Asia/Shanghai';
/** 当前北京时刻（dayjs，已带时区） */
export const nowBJ = () => dayjs().tz(BJ);
/** 把任意时间值转成北京时区的 dayjs */
export const bj = (d?: dayjs.ConfigType) => dayjs(d).tz(BJ);
/** 北京某日零点的 UTC ISO 字符串（发给后端做 >= 过滤） */
export const startOfDayISO = (d?: dayjs.ConfigType) => dayjs(d).tz(BJ).startOf('day').toISOString();
/** 北京某日 23:59:59.999 的 UTC ISO 字符串（发给后端做 <= 过滤） */
export const endOfDayISO = (d?: dayjs.ConfigType) => dayjs(d).tz(BJ).endOf('day').toISOString();
/** 北京日 'YYYY-MM-DD'（发给后端按天聚合的 date 参数） */
export const dateStrBJ = (d?: dayjs.ConfigType) => dayjs(d).tz(BJ).format('YYYY-MM-DD');
/** 北京钟点展示 'YYYY-MM-DD HH:mm:ss'（默认）或自定义 pattern */
export const fmtBJ = (d?: dayjs.ConfigType, pattern = 'YYYY-MM-DD HH:mm:ss') => (d ? dayjs(d).tz(BJ).format(pattern) : '');
